import { Box } from 'grommet'
import styled, { css } from 'styled-components'

import { TopRightHexagon } from '../styles'

import { ImageWithPlaceholder } from '@components/ImageWithPlaceholder'
import Hexagon from '@public/images/gray-outline-hexagon.svg'

export const titleWrapperStyles = css`
  margin-bottom: 0;
`
export const TeamHexagon = styled(TopRightHexagon)`
  ${({ theme }) => theme.below.mobileXL`
    top: ${theme.newSpaces.xl10}px;
    display: block;
    width: 100px;
    height: 150px;
    right: -${theme.newSpaces.md}px;
  `}
`

export const Wrapper = styled(Box)`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.spaces[5] + theme.spaces[3]}px;
  margin-top: ${({ theme }) => theme.spaces[4]}px;
  width: 100%;

  ${({ theme }) => theme.below.laptop`
    margin: 0 auto ${theme.spaces[4] + theme.spaces[3]}px;
  `}
`

export const Content = styled(Box)`
  display: flex;
  flex-direction: row;
  width: 100%;

  ${({ theme }) => theme.below.laptop`
    flex-direction: column;
    justify-content: center;
  `}
`

export const Roles = styled(Box)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: 280px;
  justify-content: flex-start;
  margin: 0 auto;
  position: relative;

  ${({ theme }) => theme.below.laptop`
    justify-content: unset;
    align-items: center;
    margin: ${theme.spaces[3]}px auto;
    height: auto;
    width: 100%;
  `}

  ${({ theme }) => theme.below.tablet`
    justify-content: unset;
  `}

  ${({ theme }) => theme.below.mobileM`
    justify-content: center;
  `}
`

export const TeamImage = styled(ImageWithPlaceholder)`
  object-fit: cover;
`

export const ImageWrapper = styled(Box)`
  min-height: 379px;
  min-width: 569px;
  position: relative;

  ${({ theme }) => theme.below.laptop`
    min-height: 480px;
    min-width: unset;
  `}

  ${({ theme }) => theme.below.tablet`
    width:100%;
    min-height: 310px;
  `}

  ${({ theme }) => theme.below.mobileL`
    min-height: 200px;
  `}
`

export const RightHexagon = styled(Hexagon)`
  bottom: -145px;
  left: 100px;
  position: absolute;
  transform: scale(0.85) rotate(-160deg);

  ${({ theme }) => theme.below.laptopM`
    display: none;
  `}
`

export const LeftHexagon = styled(Hexagon)`
  bottom: -85px;
  left: 0;
  position: absolute;

  ${({ theme }) => theme.below.laptopM`
    display: none;
  `}
`
